import firebase from "firebase";

const firebaseConfig = {
  apiKey: "AIzaSyALhF5tjMtD2qHgenxd7qryD3a4R3EhEms",
  authDomain: "blog-post-373dc.firebaseapp.com",
  databaseURL: "https://blog-post-373dc.firebaseio.com",
  projectId: "blog-post-373dc",
  storageBucket: "blog-post-373dc.appspot.com",
  messagingSenderId: "200535075729",
  appId: "1:200535075729:web:c2e947fa0f12894d9c4830",
};

firebase.initializeApp(firebaseConfig);

export default firebase;
